<template>
    <div class="wai_div">
        <div class="card_div" v-for="(item, index) in DataArray" :key="index">
            <div class="card_div_item_tu">{{ item.name }}</div>
            <div class="card_div_item_cont">
                <div>{{ item.title }}</div>
                <div>{{ item.cont }}</div>
            </div>
        </div>
        <div v-show="IsShowEvent" class="card_event_div">
            <div>{{ EventData.title }}</div>
            <div>{{ EventData.cont }}</div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'CardShowVip',
    props: {
        DataArray: {
            type: Array,
            default: () => []  // [{"name":"VIP", "title": "VIP原价", "cont": "15元活动价5元"}]
        },
        IsShowEvent: {
            type: Boolean,
            default: false
        },
        EventData: {
            type: Object,
            default: () => { }
        }
    },
    data() {
        return {

        };
    },
    watch: {

    },
    methods: {

    }
}
</script>

<style scoped>
.wai_div {
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    align-content: center;
    width: 100%;
    height: 100%;
    font-size: 9px;
    justify-content: space-evenly;
    align-items: flex-start;
}

.card_div {
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    align-content: center;
    justify-content: flex-start;
    align-items: center;
    position: relative;
    width: 28vw;
    height: 8vh;
    border-radius: 15px;
    background-color: rgb(40 49 64);
    color: rgba(255, 255, 255, 1);
    z-index: 2;
    padding-left: 5px;
}

.card_div_item_tu {
    border-radius: 100%;
    background-color: #ffdbc2;
    height: 30px;
    width: 30px;
    margin-right: 10px;
    border: 2px solid #feddbd;
    display: flex;
    flex-wrap: nowrap;
    align-content: center;
    justify-content: center;
    align-items: center;
    color: rgb(0 0 0);
}

.card_div_item_cont {
    display: flex;
    flex-direction: column;
    flex-wrap: nowrap;
    align-content: flex-start;
    justify-content: center;
    align-items: flex-start;
    width: calc(100% - 35px);
    height: 100%;
    color: rgba(255, 255, 255, 1);
}

.card_event_div {
    display: flex;
    flex-direction: column;
    flex-wrap: nowrap;
    align-content: flex-start;
    justify-content: center;
    align-items: flex-start;
    position: relative;
    right: 26px;
    width: 33vw;
    height: 8vh;
    border-radius: 15px;
    background-color: #95aecc;
    color: #fff;
    padding-left: 30px;
}
</style>
